import { IPPPApp } from '../services';

export interface IAppDetail {
	AppName: string;
	StateCode: number;
	StatusCode: number;
	AppRoles: string[];
	WebResourceURL: string;
}

export interface IAppDetails {
	[app: string]: IAppDetail;
}

export interface IUserAppDebugInfo {
	IsAdminCustomizerOrSupportUser: boolean;
	FoundUserWithGivenInfo: boolean;
	CreatePermission: boolean;
	ReadPermission: boolean;
	writePermission: boolean;
	UserId: string;
	UserName: string;
	UserRoles?: any;
	AppDetails: IAppDetails;
}

export interface ILaunchUrl {
	appUrl?: string | null;
	webUrl?: string | null;
	host?: string | null;
	authenticated: boolean;
	isDynamics: boolean;
}

export interface IDiscoResult {
	'@odata.context': string;
	value: IInstance[];
}

export interface IInstance {
	IsUserSysAdmin: boolean;
	Region: string;
	Purpose?: string;
	StatusMessage: number;
	TrialExpirationDate: string;
	OrganizationType: number;
	TenantId: string;
	EnvironmentId: string;
	DatacenterId: string;
	DatacenterName: any;
	Id: string;
	UniqueName: string;
	UrlName: string;
	FriendlyName: string;
	State: number;
	Version: string;
	Url: string;
	ApiUrl: string;
	LastUpdated: string;
	SchemaType: string;
}

export type ConfigTable = 'tpg_projects' | 'msdyn_projects';

export type LoginData = {
	profile?: any;
	environments?: IInstance[];
	error?: any;
	pppApps?: IPPPApp[];
};

export class ClientTypeError extends Error {
	name = 'ClientTypeError';
}

export class DiscoveryError extends Error {
	name = 'DiscoveryError';
	constructor(message: string, public cause?: string) {
		super(message);
	}
}